import cn from "classnames";

import { Button } from "@/shared/components/ui/button/Button";
import { FA } from "@/shared/components/ui/icon";

import s from "../FileCard.module.scss";
import { FileTypeIcon, getFileTypeChipKey } from "../FileCardIcons";
import { formatFileSize } from "../fileCard.utils";
import type { FileCardLayoutProps } from "./fileCardLayout.types";

/** Sample layout — title header, two columns: metadata grid + file icon/actions */
export const FileCardSample = ({ attrs, orderBaseUrl, onOrder, onDownload }: FileCardLayoutProps) => {
  const hasFile = !!attrs.url;
  const paperTypeDisplay = attrs.customPaperType || attrs.paperTypeLabel;

  return (
    <div className={cn(s.card, s.sampleLayout)}>
      {/* Header: title + pages tag + description */}
      <div className={s.infoCol}>
        <div className={s.titleRow}>
          <span className={s.title}>{attrs.title || "Sample Paper"}</span>
          {!!attrs.pages && <span className={s.pagesTag}>{attrs.pages} pages</span>}
        </div>
        {!!attrs.description && <div className={s.description}>{attrs.description}</div>}
      </div>

      {/* Two columns: metadata grid + icon/actions */}
      <div className={s.sampleBody}>
        <div className={s.sampleMeta}>
          {!!paperTypeDisplay && (
            <div className={s.sampleMetaItem}>
              <span className={s.sampleMetaLabel}>Paper Type</span>
              <span className={s.sampleMetaValue}>{paperTypeDisplay}</span>
            </div>
          )}
          {!!attrs.academicLevelLabel && (
            <div className={s.sampleMetaItem}>
              <span className={s.sampleMetaLabel}>Academic Level</span>
              <span className={s.sampleMetaValue}>{attrs.academicLevelLabel}</span>
            </div>
          )}
          {!!attrs.citationStyleLabel && (
            <div className={s.sampleMetaItem}>
              <span className={s.sampleMetaLabel}>Citation Style</span>
              <span className={s.sampleMetaValue}>{attrs.citationStyleLabel}</span>
            </div>
          )}
          {!!attrs.disciplineLabel && (
            <div className={s.sampleMetaItem}>
              <span className={s.sampleMetaLabel}>Discipline</span>
              <span className={s.sampleMetaValue}>{attrs.disciplineLabel}</span>
            </div>
          )}
        </div>

        <div className={s.sampleSidebar}>
          <div className={s.sampleFileInfo}>
            {!!attrs.size && <span className={s.fileSize}>{formatFileSize(attrs.size)}</span>}
            <div className={s.iconWrap}>
              <FileTypeIcon ext={attrs.ext} size={44} />
              {!!attrs.ext && (
                <span className={cn(s.extChip, s[getFileTypeChipKey(attrs.ext)])}>
                  {attrs.ext.replace(".", "")}
                </span>
              )}
            </div>
          </div>
          {hasFile && (
            <div className={cn(s.sampleActions, !orderBaseUrl && s.sampleActionsEnd)}>
              <Button variant="primary" outlined onClick={onDownload} className={s.actionButton}>
                Download
                <FA icon="fa-download" />
              </Button>
              {!!orderBaseUrl && (
                <a
                  href={orderBaseUrl}
                  rel="noopener nofollow"
                  className={cn(s.orderLink, "file-card-order-link")}
                  onClick={(e) => {
                    e.preventDefault();
                    onOrder();
                  }}
                >
                  Order similar
                  <FA icon="fa-cart-shopping" />
                </a>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
